export default "__VITE_ASSET__ygmrHh2k__"